import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Welcome, Login, Console, RequireAdmin } from './console/FirelabsApp';
import { FirelabsTheme } from './console/Theme';
const Bistro = React.lazy(() => import('./components/user/aleegio/Main'));
const Gavte = React.lazy(() => import('./components/user/gavte/Gavte'));
const Privacy = React.lazy(() => import('./components/Privacy'));
export default function App() {
  return <FirelabsTheme><Suspense fallback={<div className="fl-loading">Caricamento…</div>}><Routes>
    <Route path="/" element={<Welcome />} />
    <Route path="/login" element={<Login />} />
    <Route path="/manage" element={<RequireAdmin><Console /></RequireAdmin>} />
    <Route path="/ale-e-gio-bistro" element={<Bistro />} />
    <Route path="/gavte-la-nata" element={<Gavte />} />
    <Route path="/privacy" element={<Privacy />} />
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes></Suspense></FirelabsTheme>;
}
